import { useState, useEffect } from "react";
import axios from "axios";
import { headers } from "./CommonUtils";

export const useFetch = (url, params, history, options = {}) => {
  const { enabled = true } = options;

  const [loading, setLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState({ data: [] });
  const [errorResponse, setErrorResponse] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(enabled);
  const [refreshKey, setRefreshKey] = useState(0);

  const callReFetch = () => {
    setShouldFetch(true);
    setRefreshKey((prev) => prev + 1);
  };

  useEffect(() => {
    if (!shouldFetch || !url) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(url, {
          params,
          ...headers(),
        });

        if (!response.data) {
          if (history?.push) history.push("/");
          return;
        }

        setFetchedData(response);
        setErrorResponse(false);
      } catch (error) {
        setErrorResponse(true);
      } finally {
        setLoading(false);
        setShouldFetch(false); // prevent future auto fetch
      }
    };

    fetchData();
  }, [shouldFetch, refreshKey, url, JSON.stringify(params)]);

  return {
    fetchedData,
    errorResponse,
    loading,
    callReFetch,
  };
};
